/* eslint-disable */
import { message } from 'antd'
import initPlugin from '@/plugin'
import { isNewLayout } from '@/utils/utils'

if(!sessionStorage.getItem('ums_layoutVerson')) {
  sessionStorage.setItem('ums_layoutVerson', 'v2')
}

initPlugin()

import { ConfigProvider } from 'antd';

const primaryColor = isNewLayout ? '#0099CC' : '#0da9a5'

ConfigProvider.config({
  theme: {
    primaryColor
  },
});

// 日期选择器的国际化问题
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');
export const dva = {
  config: {
    onError(e) {
      e.preventDefault()
      console.log(e)
      message.destroy()
      if (e.message) message.error(e.message)
    },
  },
  plugins: [],
}

sessionStorage.setItem('$XDataHost', 'https://query-panel.xiaoduoai.com/')

function callBack() {
  window.shopCommonComponents.registerCommonComponents() // 注册公共组件
}

function loadScript(url, callback) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = url
  script.async = true
  document.body.appendChild(script)
  script.onload = function() {
    callback()
  }
}

loadScript(
  '//jm-static.jd.com/shop-common-components/shop-common-components.iife.js?appId=JSTKSYF47EX7Q2P8NUS1',
  callBack
)
